var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function LinkedInBrand(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M15.3 15.4h-2.7v-4.2c0-1 0-2.3-1.4-2.3S9.6 10 9.6 11.1v4.2H7V6.8h2.6V8c.5-.9 1.5-1.4 2.5-1.4 2.7 0 3.2 1.8 3.2 4.1v4.7zM4 5.6c-.8 0-1.5-.7-1.5-1.5S3.2 2.5 4 2.5s1.5.7 1.5 1.5c.1.9-.6 1.6-1.5 1.6zm1.3 9.8H2.7V6.8h2.7v8.6zM16.7.1H1.3C.6 0 0 .6 0 1.4v15.4c0 .7.6 1.3 1.3 1.3h15.3c.7 0 1.3-.6 1.3-1.3V1.4C18 .6 17.4 0 16.7.1z" }) })));
}
export default LinkedInBrand;
